import { UpdateReferenceTypes, } from '@debbie/common/dist/updates/index.js';
import moment from 'moment';
import { collectionEngineV1, drainPages } from '../apis.js';
const updatesAPIV1 = collectionEngineV1('/updates', true);
const updateTypesPageSize = 250;
export const types = () => drainPages((page) => updatesAPIV1('GET', `/types?page=${page}&pageSize=${updateTypesPageSize}`), updateTypesPageSize);
export const getTodos = (updateTypeId, caseFilter, creditorId, responsibles, includeUnassigned) => updatesAPIV1('POST', `/todos/${updateTypeId}${creditorId ? `?creditorId=${creditorId}` : ''}`, {
    body: { caseFilter, responsibles, includeUnassigned },
});
export const createType = (newUpdate) => updatesAPIV1('POST', `/types`, {
    body: newUpdate,
});
export const delType = (updateTypeId) => updatesAPIV1('DELETE', `/types/${updateTypeId}`);
export const patchType = (updateTypeId, c) => updatesAPIV1('PATCH', `/types/${updateTypeId}`, { body: c });
export const getByReferenceId = (referenceId, casualConsistency) => updatesAPIV1('GET', `/${UpdateReferenceTypes.CASE}/${referenceId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const deleteUpdate = (updateId) => updatesAPIV1('DELETE', `/${updateId}`);
export const make = (update) => updatesAPIV1('POST', `/`, {
    body: update,
});
export const addTimeTrackingEntry = (updateId, from, to) => updatesAPIV1('POST', `/${updateId}/time-tracking`, {
    body: {
        from,
        to,
    },
});
export const patch = (updateId, patch) => updatesAPIV1('PATCH', `/${updateId}`, {
    body: {
        continuedAt: Object.keys(patch || {}).length === 0 ? moment().format() : undefined,
        ...patch,
    },
});
export const synchronizeResponsibles = () => updatesAPIV1('POST', '/synchronize-responsibles');
const appendResponsibleParams = (params, responsible) => {
    if (responsible == null) {
        return;
    }
    if (responsible.onlyUnassigned) {
        params.set('onlyUnassigned', 'true');
        return;
    }
    if (responsible.responsibleType != null &&
        responsible.responsibleReferenceId != null) {
        params.set('responsibleType', responsible.responsibleType);
        params.set('responsibleReferenceId', responsible.responsibleReferenceId);
    }
};
const appendScopeParams = (params, caseGroupIds, creditorIds) => {
    caseGroupIds.forEach((id) => params.append('caseGroupIds', id));
    creditorIds.forEach((id) => params.append('creditorIds', id));
};
export const insightsTimeTracking = (from, to, caseGroupIds, creditorIds, updateTypeId, responsible) => {
    const params = new URLSearchParams({ from, to });
    appendScopeParams(params, caseGroupIds, creditorIds);
    if (updateTypeId != null) {
        params.set('updateTypeId', updateTypeId);
    }
    appendResponsibleParams(params, responsible);
    return updatesAPIV1('GET', `/insights/time-tracking?${params.toString()}`);
};
export const insightsTimeTrackingPerUpdateType = (updateTypeId, from, to, caseGroupIds, creditorIds, responsible) => {
    const params = new URLSearchParams({ from, to });
    appendScopeParams(params, caseGroupIds, creditorIds);
    appendResponsibleParams(params, responsible);
    return updatesAPIV1('GET', `/insights/time-tracking/${updateTypeId}?${params.toString()}`);
};
export const insightsTimeTrackingDeepdive = (updateTypeId, userId, from, to, caseGroupIds, creditorIds) => {
    const params = new URLSearchParams({ from, to });
    appendScopeParams(params, caseGroupIds, creditorIds);
    return updatesAPIV1('GET', `/insights/time-tracking/${updateTypeId}/user/${userId}?${params.toString()}`);
};
export const insightsTaskBacklog = (caseGroupIds, creditorIds, updateTypeId, responsible) => {
    const params = new URLSearchParams();
    appendScopeParams(params, caseGroupIds, creditorIds);
    if (updateTypeId != null) {
        params.set('updateTypeId', updateTypeId);
    }
    appendResponsibleParams(params, responsible);
    const qs = params.toString();
    return updatesAPIV1('GET', `/insights/task-backlog${qs ? `?${qs}` : ''}`);
};
export const insightsTaskQueueDuration = (from, to, caseGroupIds, creditorIds, updateTypeId, responsible) => {
    const params = new URLSearchParams({ from, to });
    appendScopeParams(params, caseGroupIds, creditorIds);
    if (updateTypeId != null) {
        params.set('updateTypeId', updateTypeId);
    }
    appendResponsibleParams(params, responsible);
    return updatesAPIV1('GET', `/insights/queue-duration?${params.toString()}`);
};
//# sourceMappingURL=updates.js.map